export enum TypeReport{
    ASN_Report = 'ASNReport',
    Near_Expiry = 'NearExpiry',
    ASNs_By_WH_Org = 'ASNsByWH_Org',
    DN_Confirm = 'DNConfirm',
    Stock_Location = 'Stock_Location',
    Stock_LPN_Wise ='Stock_LPN_Wise',
    Stock_SKU_Wise = 'Stock_SKU_Wise',
    Stock_Zone_Wise = 'Stock_Zone_Wise',
    Empty_Location = 'Empty_Location',
    Order_Summary_Planning = 'Order_Summary_Planning',
    Inbound_Summary_Date_Range = 'Inbound_Summary_Date_Range',
    Outbound_Summary_Date_Range = 'Outbound_Summary_Date_Range',
    LPN_Count = 'LPNCount'

}